export default {
      id: "icon-facebook-widget-usage",
      viewBox: "0 0 39 20",
      url: __webpack_public_path__ + "icons.svg#icon-facebook-widget",
      toString: function () {
        return this.url;
      }
    }